export default {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-speedometer"

      /*badge: {
        variant: 'primary',
        text: 'NEW'
      }*/
    },
    {
      name: "Direct Ship",
      url: "/expedite",
      icon: "fa fa-fighter-jet"
      /*badge: {
        variant: 'primary',
        text: 'NEW'
      }*/
    },
    {
      name: "One Time Orders",
      url: "/orders",
      icon: "fa fa-dropbox"
      /*badge: {
        variant: 'primary',
        text: 'NEW'
      }*/
    },
    {
      name: "Client Direct",
      url: "/client-direct",
      icon: "fa fa-envelope-open"
    },
    {
      name: "Production Hub",
      url: "/production",
      icon: "fa fa-simplybuilt",
      meta: "forAdmin"
    },
    {
      name: "Shipping Hub",
      url: "/shipping",
      icon: "fa fa-truck",
      meta: "forAdmin"
    },
    {
      name: "Ticket Scan",
      url: "/scanning",
      icon: "fa fa-barcode",
      meta: "forLL"
    }
    // ,
    // {
    //   name: "Calendar",
    //   url: "/calendar",
    //   icon: "fa fa-calendar",
    //   meta: "forAdmin"
    // }
  ]
};
